export default __webpack_public_path__ + "static/media/juice.dd087137.c0ad702e.svg";